import { writable } from 'svelte/store';
// Models
import UserNote from '@/Models/UserNote.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta = { pagination: {} };

	const { subscribe, set, update } = writable();

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getFilterMeta() {
			if (meta && meta.pagination) {
				// eslint-disable-next-line no-unused-vars
				const { pagination, ...filterMeta } = meta;
				return filterMeta.available_filters;
			}
			return meta;
		},

		getUserNotes(userId, noteCategoryId, pagination = null) {
			let userNote = new UserNote();
			// we need a custom resource URL for this endpoint
			userNote.resourceUrl = () => {
				return `${userNote.baseUrl()}/users/${userId}/notes`;
			};

			// Apply category filter if provided
			if (noteCategoryId) {
				userNote = userNote.where('user_note_category_id', noteCategoryId);
			}

			let results = pagination ? userNote.paginate(pagination.size, pagination.number) : userNote.all();
			return results
				.then((result) => {
					meta = result.meta;
					set(result.data);
				})
				.catch((e) => {
					console.error(e);
				});
		},

		saveUserNote(userId, note, noteCategoryId) {
			let userNote = new UserNote();
			userNote.resourceUrl = () => {
				return `${userNote.baseUrl()}/users/${userId}/notes`;
			};

			return userNote.create({
				note,
				note_category_id: noteCategoryId
			});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
